import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddScheduleState, addScheduleFeatureKey } from './add-schedule.reducer';

const getAddScheduleFeature = createFeatureSelector<AddScheduleState>(addScheduleFeatureKey);

export const getAddScheduleCallState = createSelector(getAddScheduleFeature, (state) => {
   return state.callState;
});
